'use strict';
/*
  px7 — after px7.digital. Light off-white paper, a calm transitional serif, and a
  muted gold ITALIC accent for the key word (the site's "human" highlight). Hairline
  rules, tiny px7 wordmark. Quiet, premium, human. Mixed case (editorial).
*/
const { layoutCue } = require('./_common');
const { roundRect } = require('../lib/draw');

const SUP = '/System/Library/Fonts/Supplemental/', S = '/System/Library/Fonts/';
const SERIF  = [SUP + 'Charter.ttc', S + 'Hoefler Text.ttc', SUP + 'Georgia Bold.ttf', SUP + 'Times New Roman Bold.ttf'];
const ITALIC = [SUP + 'Georgia Italic.ttf', SUP + 'Times New Roman Italic.ttf', SUP + 'Baskerville.ttc'];

const palette = { bg: '#f6f4ee', panel: '#ffffff', ink: '#1f1d18', fg: '#1f1d18', accent: '#9a875a', muted: '#8c8678' };
const HALO = 'rgba(246,244,238,0.92)';

function init(st) {
  st.s.serif  = st.tk.registerFamily('ForgePX7', SERIF, '900') || undefined;
  st.s.italic = st.tk.registerFamily('ForgePX7It', ITALIC, '900') || st.s.serif;
}

function background(ctx, st) {
  const { W, H } = st;
  if (!st.overlayMode) {
    ctx.fillStyle = palette.bg; ctx.fillRect(0, 0, W, H);
    // hairline rules echoing the site's section dividers
    ctx.strokeStyle = 'rgba(31,29,24,0.10)'; ctx.lineWidth = 2;
    [0.2, 0.82].forEach(fy => { ctx.beginPath(); ctx.moveTo(W * 0.08, H * fy); ctx.lineTo(W * 0.92, H * fy); ctx.stroke(); });
    ctx.save(); ctx.globalAlpha = 0.03; ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(st.tk.grain(), 0, 0); ctx.restore();
  }
  // over footage: keep it clean — the per-word haloes carry legibility.
}

function paintToken(ctx, o) {
  const { T, cx, cy, px, scl, alpha, emph, st, ghost } = o, tk = st.tk;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl, scl);
  ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (ghost) { ctx.font = tk.font(px, 900, st.s.serif); ctx.fillStyle = 'rgba(31,29,24,0.16)'; ctx.fillText(T, 0, 0); ctx.restore(); return; }
  // clean serif (gold italic for the key word) on the white card — no outline.
  ctx.font = emph ? tk.font(px, 900, st.s.italic) : tk.font(px, 900, st.s.serif);
  ctx.fillStyle = emph ? palette.accent : palette.ink; ctx.fillText(T, 0, 0);
  ctx.restore();
}

// crisp white card with a hairline border behind each line — the site's cards.
function prePaintLine(ctx, o) {
  const { cx, cy, w, px, alpha } = o;
  const padX = px * 0.46, h = px * 1.3, r = px * 0.16;
  const X = cx - w / 2 - padX, Y = cy - px * 0.54, W = w + padX * 2;
  ctx.save(); ctx.globalAlpha = alpha;
  ctx.shadowColor = 'rgba(40,35,20,0.14)'; ctx.shadowBlur = px * 0.45; ctx.shadowOffsetY = px * 0.07;
  ctx.fillStyle = '#fbf9f3'; roundRect(ctx, X, Y, W, h, r); ctx.fill();
  ctx.shadowColor = 'transparent';
  ctx.strokeStyle = 'rgba(31,29,24,0.12)'; ctx.lineWidth = px * 0.016; roundRect(ctx, X, Y, W, h, r); ctx.stroke();
  ctx.restore();
}

// small tracked uppercase label, like the site's "PX7 DIGITAL"
function trackedLabel(ctx, tk, text, x, y, size, ls, family, color) {
  ctx.save(); ctx.font = tk.font(size, 700, family); ctx.fillStyle = color; ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic';
  let cx = x; for (const ch of text) { ctx.fillText(ch, cx, y); cx += ctx.measureText(ch).width + ls; }
  ctx.restore();
}

function drawCue(ctx, st) {
  const anchor = st.mode === 'talk' ? 0.76 : 0.6;
  layoutCue(ctx, st, { sizes: { big: 108, mid: 90, small: 56 }, anchor, safeW: 0.82, reveal: 0.26, stagger: 0.07, trail: 0, trans: 0.26, family: st.s.serif, paintToken, prePaintLine });
}

function overlay(ctx, st) {
  const tk = st.tk;
  ctx.save(); ctx.globalAlpha = 0.025; ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(tk.grain(), -Math.random() * 60, -Math.random() * 60); ctx.restore();
  ctx.drawImage(tk.vignette(st.overlayMode ? 0.3 : 0.45, 400), 0, 0);
  ctx.fillStyle = palette.accent; ctx.fillRect(0, st.H - 5, st.W * st.progress, 5);
}

module.exports = { id: 'px7', label: 'Editorial Light · airy serif', palette, init, background, drawCue, overlay, paintToken };
